import React, { useState } from 'react';
import { teamMembers } from '../mock/teamData';

const TeamSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === teamMembers.length - 3 ? 0 : prevIndex + 1
    );
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? teamMembers.length - 3 : prevIndex - 1
    );
  };

  const visibleMembers = [
    teamMembers[(currentIndex + teamMembers.length - 1) % teamMembers.length],
    teamMembers[currentIndex],
    teamMembers[(currentIndex + 1) % teamMembers.length]
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
      </div>
    </section>
  );
};

export default TeamSection;